define('responsive-gameday/views/render/InningPlaysViewRender',['require','exports','module','./ViewRender','../../helpers/PitchListToggle','Wax/get!view-templates/playByPlay/inning','Wax/get!view-templates/playByPlay/play','Wax/get!view-templates/playByPlay/action','Wax/get!view-templates/playByPlay/pitch'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        PitchListToggle = require("../../helpers/PitchListToggle"),
        Superclass;

    function InningPlaysViewRender(){
        Superclass.constructor.call(this,
            require( 'Wax/get!view-templates/playByPlay/inning' ),{
                playView    : require( "Wax/get!view-templates/playByPlay/play" ),
                actionView : require( 'Wax/get!view-templates/playByPlay/action' ),
                pitchView   : require( "Wax/get!view-templates/playByPlay/pitch" )
            }
        );
        var view = this;
        view.viewState.activeClass= function (arg) {
            return this.num == view.viewState.activeInning;
        };
    }
    ViewRender.spawn(InningPlaysViewRender).define({
        setPitchToggler : function(controller){
            var pitchToggler = this.pitchToggler = this.pitchToggler || new PitchListToggle(controller);

            pitchToggler.className = 'pitches_visible';
            pitchToggler.on(controller.childWrapper || controller.view, '.play .detail');

            this.viewState.pitchState=pitchToggler.pitchesState;

        }
    });

    Superclass=InningPlaysViewRender.superclass;

    return InningPlaysViewRender;
});
